export enum EPollType {
    DATE_TIME = 'DATE_TIME',
    TEXT = 'TEXT',
  }

  export enum EPollResultType {
    NUMBER = 'NUMBER',
    PERCENTAGE = 'PERCENTAGE',
  }